"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _videoBackgroundButton = _interopRequireDefault(require("./video-background-button"));
var _backgroundImage = _interopRequireDefault(require("./background-image"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var VideoBackground = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(VideoBackground, _React$Component);
  function VideoBackground(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var desktopWidth = 768;
    _this.heroVideo = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      videoIsPlaying: false,
      readyState: 0,
      isDesktop: typeof window !== 'undefined' && window.outerWidth > desktopWidth,
      hideVideoOnMobile: false
    };
    _this.mql = null;
    _this.toggleVideoPlay = _this.toggleVideoPlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.videoPlay = _this.videoPlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.videoPause = _this.videoPause.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleVideoReady = _this.handleVideoReady.bind((0, _assertThisInitialized2["default"])(_this));
    _this.shouldPreload = _this.shouldPreload.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleVideoMobileShow = _this.handleVideoMobileShow.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = VideoBackground.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$state = this.state,
      readyState = _this$state.readyState,
      isDesktop = _this$state.isDesktop;
    var _this$props = this.props,
      hideVideoOnMobile = _this$props.hideVideoOnMobile,
      autoPlayVideoOnMobile = _this$props.autoPlayVideoOnMobile;
    if (this.heroVideo.current !== null && readyState === 0) {
      this.heroVideo.current.addEventListener('pause', this.videoPause);
      if (isDesktop || autoPlayVideoOnMobile) {
        this.handleVideoReady();
      }
      if (typeof window !== 'undefined' && (isDesktop || autoPlayVideoOnMobile)) {
        this.heroVideo.current.addEventListener('canplay', this.videoPlay);
      }

      /* eslint-disable */
      this.setState(function (prevState) {
        readyState: prevState.readyState;
      });
      /* eslint-enable */
    }
    if (hideVideoOnMobile && typeof window !== 'undefined') {
      this.setupMediaQuery();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.heroVideo.current !== null) {
      this.heroVideo.current.removeEventListener('canplay', this.videoPlay);
      this.heroVideo.current.removeEventListener('pause', this.videoPause);
    }
  };
  _proto.handleVideoMobileShow = function handleVideoMobileShow(mql) {
    this.setState({
      hideVideoOnMobile: mql.matches
    });
  };
  _proto.handleVideoReady = function handleVideoReady() {
    this.videoPlay();
  };
  _proto.setupMediaQuery = function setupMediaQuery() {
    this.mql = window.matchMedia('(max-width: 768px)');
    this.mql.addListener(this.handleVideoMobileShow.bind(this));
    this.handleVideoMobileShow(this.mql);
  };
  _proto.videoPause = function videoPause() {
    this.heroVideo.current.pause();
    this.setState({
      videoIsPlaying: false
    });
  };
  _proto.videoPlay = function videoPlay() {
    this.heroVideo.current.play();
    this.setState({
      videoIsPlaying: true
    });
  };
  _proto.toggleVideoPlay = function toggleVideoPlay(videoIsPlaying) {
    var _this$props$data = this.props.data,
      market = _this$props$data.config.market,
      source = _this$props$data.video.source;
    if (videoIsPlaying) {
      this.videoPause();
    } else {
      this.videoPlay();
    }
    if (market.toLowerCase() === 'nl' && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: videoIsPlaying ? 'videoPause' : 'videoPlay',
        video: source
      });
    }
  };
  _proto.shouldPreload = function shouldPreload(isDesktop) {
    var autoPlayVideoOnMobile = this.props.autoPlayVideoOnMobile;
    if (typeof window !== 'undefined' && (isDesktop || autoPlayVideoOnMobile)) {
      return 'auto';
    }
    return 'none';
  };
  _proto.renderVideo = function renderVideo(data, theme) {
    var loopLocal = handleNestedProp(data, 'data.video.loop');
    var _this$state2 = this.state,
      videoIsPlaying = _this$state2.videoIsPlaying,
      isDesktop = _this$state2.isDesktop;
    var classes = this.props.classes;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("video", {
      ref: this.heroVideo,
      className: classes,
      loop: loopLocal || 'true',
      muted: true,
      preload: this.shouldPreload(isDesktop),
      playsInline: true,
      poster: handleNestedProp(data, 'data.image.image')
    }, /*#__PURE__*/_react["default"].createElement("source", {
      src: handleNestedProp(data, 'data.video.source'),
      type: "video/mp4"
    })), /*#__PURE__*/_react["default"].createElement(_videoBackgroundButton["default"], {
      data: data,
      videoIsPlaying: videoIsPlaying,
      theme: theme,
      toggleVideoPlay: this.toggleVideoPlay
    }));
  };
  _proto.renderBackground = function renderBackground(data, theme) {
    // const imageWidth = 2160;
    var classes = this.props.classes;
    return /*#__PURE__*/_react["default"].createElement(_backgroundImage["default"], {
      image: handleNestedProp(data, 'data.image.image'),
      altText: handleNestedProp(data, 'data.image.altText'),
      size: data.size,
      classes: classes,
      theme: theme
    });
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      data = _this$props2.data,
      theme = _this$props2.theme;
    var hideVideoOnMobile = this.state.hideVideoOnMobile;
    return !hideVideoOnMobile ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.renderVideo(data, theme)) : null;
  };
  return VideoBackground;
}(_react["default"].Component);
VideoBackground.defaultProps = {
  data: {},
  theme: {}
};
var _default = VideoBackground;
exports["default"] = _default;